import React from 'react';
const ReplyContext = /*#__PURE__*/React.createContext();
const ReplyDispatchContext = /*#__PURE__*/React.createContext();
const initialReplyState = {
  openModals: []
};
function replyReducer(state, action) {
  switch (action.type) {
    case 'SHOW_REPLY_MODAL':
      return {
        ...state,
        openModals: [...state.openModals, action.payload]
      };
    case 'HIDE_REPLY_MODAL':
      return {
        ...state,
        openModals: state.openModals.filter(topicId => topicId !== action.payload)
      };
    default:
      throw new Error(`Unhandled action type: ${action.type}`);
  }
}
function ReplyProvider({
  children
}) {
  const [state, dispatch] = React.useReducer(replyReducer, initialReplyState);
  return /*#__PURE__*/React.createElement(ReplyContext.Provider, {
    value: state
  }, /*#__PURE__*/React.createElement(ReplyDispatchContext.Provider, {
    value: dispatch
  }, children));
}
function useReplyState() {
  const context = React.useContext(ReplyContext);
  if (context === undefined) {
    throw new Error('useReplyState must be used within a ReplyProvider');
  }
  return context;
}
function useReplyDispatch() {
  const context = React.useContext(ReplyDispatchContext);
  if (context === undefined) {
    throw new Error('useReplyDispatch must be used within a ReplyProvider');
  }
  return context;
}
export { ReplyProvider, useReplyState, useReplyDispatch };
//# sourceMappingURL=index.js.map